export const keys = {
  token: 'token',
  refreshToken: 'refreshToken',
  user: 'user',
  permissions: 'permissions',
  rememberedEmail: 'rememberedEmail',
  language: 'language',
} as const;

export const regex = {
  email: /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,64}$/,
  phone: /^\(\d{3}\) \d{3}-\d{4}$/,
  zip: /^\d{5}(-\d{4})?$/,
  npi: /^\d{10}$/,
  dob: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/,
  numericOnly: /^\d+$/,
};

export const PASSWORD_RULES = [
  { key: 'minlength', label: 'At least 8 characters' },
  { key: 'uppercase', label: 'One uppercase letter' },
  { key: 'lowercase', label: 'One lowercase letter' },
  { key: 'digit', label: 'One number' },
  { key: 'symbol', label: 'One special character' },
] as const;

export const AUTH_CONSTANTS = {
  passwordMinLength: 8,
  passwordMaxLength: 64,
};

export const VALIDATION_MESSAGES: Record<string, string> = {
  required: 'This field is required.',
  email: 'Enter a valid email address.',
  pattern: 'The value entered is not in the expected format.',
  minlength: 'The value entered is too short.',
  maxlength: 'The value entered is too long.',
  passwordStrength: 'Password does not meet the required complexity.',
  passwordMismatch: 'Passwords do not match.',
  invalidDate: 'Enter a valid date.',
  futureDate: 'The date cannot be in the future.',
};

export const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
];

export const FIREBASE_ERROR_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'The email or password you entered is incorrect.',
  'auth/invalid-email': 'The email or password you entered is incorrect.',
  'auth/user-not-found': 'The email or password you entered is incorrect.',
  'auth/wrong-password': 'The email or password you entered is incorrect.',
  'auth/user-disabled': 'This account has been disabled. Contact your administrator.',
  'auth/too-many-requests': 'Too many failed attempts. Try again later.',
  'auth/network-request-failed': 'Network error. Check your connection and try again.',
};
